//
// Copyright 2020 DXOS.org
//

import { lazy } from 'react';

export const SignalArticle = lazy(() => import('./SignalArticle/index.ts'));
export const SwarmArticle = lazy(() => import('./SwarmArticle/index.ts'));
export const NetworkArticle = lazy(() => import('./NetworkArticle/index.ts'));
